module.exports = __webpack_public_path__ + "img/salmon.f1348a7a.png";